/**
 * POINT serializer.
 */

import type { Entity } from '../../../../state/store';
import type { DxfWriteContext } from '../types';
import type { DxfStreamWriter } from '../DxfStreamWriter';
import { entityPrologue } from './common';

export function writePoint(w: DxfStreamWriter, ctx: DxfWriteContext, e: Entity, owner: string): void {
    const p = (e.data as Record<string, unknown>).position as number[];
    if (!Array.isArray(p)) return;
    entityPrologue(w, ctx, e, 'POINT', owner);
    w.pair(100, 'AcDbPoint');
    w.pair(10, p[0] ?? 0).pair(20, p[1] ?? 0).pair(30, p[2] ?? 0);
}
